import { createContext, useCallback, useContext, useMemo } from "react";
import { ToastStack, useToastStack } from "../../components/ui/ToastStack";
import { normalizeApiError } from "../../utils/normalizeApiError";
import SuccessScreenHost from "../../components/common/SuccessScreenHost";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const { toasts, addToast, removeToast } = useToastStack();

  const success = useCallback(
    (message, options = {}) => {
      const text =
        typeof message === "string"
          ? message
          : message?.message || message?.title || "Updated successfully";
      const title =
        typeof message === "object" && message?.title
          ? message.title
          : options.title || "Successfully completed";
      addToast(text, "success", { ...options, title });
    },
    [addToast]
  );

  const error = useCallback(
    (message) => {
      addToast(normalizeApiError(message), "error");
    },
    [addToast]
  );

  const value = useMemo(
    () => ({
      success,
      error,
    }),
    [success, error]
  );

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastStack toasts={toasts} onRemove={removeToast} />
      <SuccessScreenHost />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
}
